import React from "react";
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import AgyleToggleButtons from "../../../components/ui/buttons/agyleToggleButtons";
import {admissionStatusTypes} from "../bookedAdmissions";

export const useStyles = makeStyles((theme) => ({

}));

const Worklist = (props) => {
    const classes = useStyles();

    return(
        <Grid container direction="row" justifyContent={"space-between"}>

            <Grid item xs={12}>
                <AgyleToggleButtons
                    onChange={props.setAdmissionStatus}
                    value={props.admissionStatus}
                    size="small"
                    options={[
                        {value: admissionStatusTypes.WORKLIST, label: "Worklist"},
                        {value: admissionStatusTypes.UNSCHEDULED, label: "Unscheduled"},
                        {value: admissionStatusTypes.SCHEDULED, label: "Scheduled"},
                    ]}
                    minWidth={100}
                />
            </Grid>
            <Grid item xs={12}>
                LIST
            </Grid>
            <Grid item xs={12}>
                {props.admissionView}
            </Grid>
            <Grid item xs={12}>
                search: {props.searchPhrase}
            </Grid>

        </Grid>
    )
}

export default Worklist